import logo from "../assets/wamglammz-logo.png";
import logo2 from "../assets/wamglammz-logo2.png";
import { Link } from "react-router-dom";


export default function Footer() {
    return (
        <footer className="bg-[#F5F9FF] pt-16 pb-10">

            <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        

                {/* TOP SECTION */}
                <div className="flex flex-col md:flex-row justify-between gap-10">


                    {/* LOGO + DESC + SOCIALS */}
                    <div>
                        <div className="flex items-center gap-2">
                            <img src={logo} alt="logo" className="h-14 object-contain" />

                            <img
                                src={logo2}
                                alt="WamGlammz"
                                className="h-6 object-contain"
                            />
                        </div>

                        <p className="mt-4 text-[14] text-gray-500 leading-[22px] max-w-xs">
                            A curated sanctuary for beauty, wellness, and lifestyle artistry.
                            Connecting the elite with the exceptional.
                        </p>

                        {/* SOCIAL ICONS */}
                        <div className="flex items-center gap-5 mt-6 text-xl text-gray-400">
                            <a 
                                href="http://www.linkedin.com/in/wamglammz" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="hover:text-[#0A66C2] transition-colors duration-300"
                                aria-label="LinkedIn"
                            >
                                <i className="fa-brands fa-linkedin"></i>
                            </a>
                            <a 
                                href="https://www.instagram.com/wamglammz/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="hover:text-[#E1306C] transition-colors duration-300"
                                aria-label="Instagram"
                            >
                                <i className="fa-brands fa-instagram"></i>
                            </a>
                        </div>
                    </div>

                    {/* COLUMN 1 */}
                    <div>
                        <h4 className="text-[#1E40AF] font-semibold mb-4 text-sm">
                            Platform Links
                        </h4>

                        <ul className="space-y-3 text-gray-500 text-sm">
                            <li>
                                <Link to="/why-wamglammz" className="hover:text-blue-600 cursor-pointer transition-colors">
                                    Why Wamglammz
                                </Link>
                            </li>
                            <li>
                                <Link to="/blog" className="hover:text-blue-600 cursor-pointer transition-colors">
                                    Blogs
                                </Link>
                            </li>
                            {/* <li>
                                <Link to="/book/aurora-artistry" className="hover:text-blue-600 cursor-pointer transition-colors">
                                    Book Services
                                </Link>
                            </li> */}
                        </ul>
                    </div>

                    {/* COLUMN 2 */}
                    <div>
                        <h4 className="text-[#1E40AF] font-semibold mb-4 text-sm">
                            Features
                        </h4>

                        <ul className="space-y-3 text-gray-500 text-sm">
                            <li className="hover:text-blue-600 cursor-pointer transition-colors">
                                Highly Rated Artists
                            </li>
                            <li className="hover:text-blue-600 cursor-pointer transition-colors">
                                Referral Rewards
                            </li>
                            <li className="hover:text-blue-600 cursor-pointer transition-colors">
                                <Link to="/for-business" className="hover:text-blue-600 cursor-pointer transition-colors">
                                    For Business
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* COLUMN 3 */}
                    <div>
                        <h4 className="text-[#1E40AF] font-semibold mb-4 text-sm">
                            Support
                        </h4>

                        <ul className="space-y-3 text-gray-500 text-sm">
                            <li>
                                <Link to="/contact-us" className="hover:text-blue-600 cursor-pointer transition-colors">
                                    Contact Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/terms" className="hover:text-blue-600 cursor-pointer transition-colors">
                                    Terms of Service
                                </Link>
                            </li>
                            <li>
                                <Link to="/privacy-policy" className="hover:text-blue-600 cursor-pointer transition-colors">
                                    Privacy Policy
                                </Link>
                            </li>
                        </ul>
                    </div>

                </div>

                {/* DIVIDER */}
                <div className="border-t border-gray-200 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center text-[12] text-gray-400">

                    <p>© 2026 Wamglammz. All rights reserved.</p>

                    <div className="flex gap-6 mt-4 md:mt-0">
                        <span className="cursor-pointer hover:text-blue-600 transition-colors">
                            <Link to="/about-shy" className="hover:text-blue-600 cursor-pointer transition-colors">
                                About Shy
                            </Link>
                        </span>
                        <a
                                href="https://docs.google.com/forms/d/e/1FAIpQLSclujCjJKuYXRS7gY4cEk4b3NjhZ3aa_qPw6-SLm_jHSP8W4Q/viewform"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="cursor-pointer hover:text-blue-600 transition-colors"
                            >Suggestions
                            </a>
                    </div>

                </div>

            </div>

        </footer>
    );
}
